import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-niveles',
  templateUrl: './niveles.component.html',
  styleUrls: ['./niveles.component.scss']
})
export class NivelesComponent implements OnInit {

  @Input() numCategoria: any;
  numero: any;

  content: boolean = true;
  benefi: boolean = false;
  comoNivel: boolean = false;
  videos: boolean = false;

  lvl1: boolean = false;
  lvl2: boolean = false;
  lvl3: boolean = false;
  lvl4: boolean = false;

  activeCarr1: boolean = false;
  activeCarr2: boolean = false;

  parametro: any;
  urlVideo: SafeUrl;

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer) {
    this.parametro = this.route.snapshot.paramMap.get('lvl');
    this.numero = parseInt(this.parametro);
  }

  ngOnInit(): void {
    switch (this.numero || parseInt(this.numCategoria)) {
      case 1:
        this.lvl1 = true;
        this.activeCarr2 = true;
        break;
      case 2:
        this.lvl2 = true;
        this.activeCarr1 = true;
        break;
      case 3:
        this.lvl3 = true;
        this.activeCarr1 = true;
        break;
      case 4:
        this.lvl4 = true;
        this.activeCarr1 = true;
        break;
    }
  }

  beneficios(): void {
    this.content = false;
    this.benefi = true;
    this.comoNivel = false;
  }

  comoSubir(): void {
    this.content = false;
    this.benefi = false;
    this.comoNivel = true;
  }

  verVideo(num: number) {
    switch (num) {
      case 1:
        this.content = false;
        this.benefi = false;
        this.comoNivel = false;
        let video = 'https://www.youtube.com/embed/4uu-Zyu1v8g';
        this.urlVideo = this.sanitizer.bypassSecurityTrustResourceUrl(video);
        this.videos = true;
        break;
      case 2:
        this.content = false;
        this.benefi = false;
        this.comoNivel = false;
        let video2 = 'https://www.youtube.com/embed/zGr_WDOVIjY';
        this.urlVideo = this.sanitizer.bypassSecurityTrustResourceUrl(video2);
        this.videos = true;
        break;
      case 3:
        this.content = false;
        this.benefi = false;
        this.comoNivel = false;
        let video3 = 'https://www.youtube.com/embed/np0MaaQPdSs';
        this.urlVideo = this.sanitizer.bypassSecurityTrustResourceUrl(video3);
        this.videos = true;
        break;
      case 4:
        this.content = false;
        this.benefi = false;
        this.comoNivel = false;
        let video4 = 'https://www.youtube.com/embed/bY3NzlnQVOI';
        this.urlVideo = this.sanitizer.bypassSecurityTrustResourceUrl(video4);
        this.videos = true;
        break;
    }
  }

  volver(): void {
    this.content = true;
    this.benefi = false;
    this.comoNivel = false;
    this.videos = false;
  }

}
